module.exports = __webpack_public_path__ + "assets/places2_black.8f5da8d0.svg";